import { createActionGroup, props } from "@ngrx/store";

// **************************************************************************
// CORE SETTINGS ACTIONS
// Application-wide settings (not page-specific)
// **************************************************************************
export const CoreSettingsActions = createActionGroup({
    source: "Settings",
    events: {
        "Set Available Langs": props<{ langs: string[] }>(),
    },
});
